module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"announcement":"Announcement"},"id":{"announcement":"Pengumuman"}}')
  delete Component.options._Ctor
}
